<template>
  <div>
    <v-toolbar elevation="0">
      <v-btn :to="{ name: 'configs.insurers_portal.users' }" exact icon>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>
        {{ user.name }}
      </v-toolbar-title>
    </v-toolbar>

    <v-card flat>
      <v-card-text>
        {{ __("status") }}:
        <v-chip label x-small :color="user.is_active ? 'green' : 'red'" dark>
          {{ user.is_active ? __("ativo") : __("inativo") }}
        </v-chip>
        <br />
        {{ __("email") }}: {{ user.email }} <br />
        {{ __("nome do usuário") }}: {{ user.username }} <br />
        {{ __("telefone") }}: {{ user.phone_number || "---" }} <br />
        {{ __("idioma") }}: {{ user.language_id }} <br />
        {{ __("pode utilizar o Portal HCM") }}:
        {{ user.can_access_portal_hcm ? __("sim") : __("não") }}
      </v-card-text>
      <v-list>
        <v-list-item @click="remove()" class="red--text" link>
          <v-list-item-title>
            <v-icon color="red" left>mdi-close</v-icon>
            {{ __("remover da companhia") }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>

    <ConfirmationDialog ref="confirmation" />
  </div>
</template>

<script>
import { show, remove } from "@/services/PortalCompanhias/insurer_users";
import ToastsMixin from "@/mixins/ToastsMixin";
import ConfirmationDialog from "@/components/tools/ConfirmationDialog.vue";
import i18n from "@/mixins/i18n";

export default {
  mixins: [ToastsMixin, i18n],

  components: {
    ConfirmationDialog,
  },

  props: {
    id: [String, Number],
    user_id: [String, Number],
  },

  data() {
    return {
      i18n_prefix: "settings",
      loading: false,
      user: null,
    };
  },

  methods: {
    async load() {
      this.loading = true;

      try {
        this.user = await show(this.id, this.user_id);
      } catch (error) {
        this.toastError(this.__("falha ao carregar utilizador", "settings"));
        this.$router.replace({
          name: "configs.insurers_portal.users",
        });
      } finally {
        this.loading = false;
      }
    },

    async remove() {
      this.$refs.confirmation.confirm(
        `${this.__("remover", "settings")} ${this.user.name} ${this.__(
          "da companhia?",
          "settings"
        )}`,
        async ({ startLoading, stopLoading, close }) => {
          startLoading();
          try {
            await remove(this.id, this.user_id);
            this.toast(this.__("utilizador removido da companhia", "settings"));
            this.$router.replace({
              name: "configs.insurers_portal.users",
            });
            close();
          } catch (error) {
            this.toastError(
              this.__(
                "não foi possível remover o utilizador da companhia",
                "settings"
              )
            );
          } finally {
            stopLoading();
          }
        },
        null,
        {
          color: "red",
          confirmText: this.__("remover", "settings"),
          cancelText: this.__("manter utilizador", "settings"),
        }
      );
    },
  },

  computed: {},

  created() {
    this.load();
  },
};
</script>
